// Configuration + helpers for the unified /gift page.

// The gift-voucher artwork templates that already exist end-to-end: each has a
// PNG on S3 that the backend fills in with the course name + redemption code
// when the recipient email is sent. Thumbnails are pulled from the same bucket.
export interface VoucherTemplate {
  id: string; // matches Merchant::GiftOrder template + S3 filename
  label: string;
  occasions: string[];
  badge?: string;
}

export const VOUCHER_TEMPLATES: VoucherTemplate[] = [
  { id: "whale", label: "Gift voucher for your brain", occasions: ["professional", "any-occasion"] },
  { id: "oprah", label: "You get a voucher!", occasions: ["any-occasion", "milestone"] },
  { id: "birthday", label: "Happy birthday", occasions: ["birthday"] },
  { id: "christmas", label: "Merry Christmas", occasions: ["christmas"] },
  { id: "valentines", label: "Roses are red", occasions: ["valentines"] },
  { id: "single", label: "So you're single", occasions: ["valentines", "any-occasion", "apology"] },
  { id: "purrfect", label: "A purrfect gift", occasions: ["any-occasion", "apology"] },
];

export const OCCASIONS: { id: string; label: string }[] = [
  { id: "all", label: "Any" },
  { id: "any-occasion", label: "Just because" },
  { id: "professional", label: "Professional" },
  { id: "birthday", label: "Birthday" },
  { id: "christmas", label: "Christmas" },
  { id: "valentines", label: "Valentine's" },
  { id: "apology", label: "Apology" },
  { id: "milestone", label: "Milestone" },
];

export const voucherThumb = (template: string) =>
  `https://s3.amazonaws.com/42courses-user/coupons/${template}.png`;

// Volume-discount tiers. These MUST mirror the server
// (Merchant::Quotation::Discount#special_discount_percentage): the server is the
// source of truth for what is actually charged; these are only for the live
// ladder + per-unit display on the page.
export const TEAM_PLANS_THRESHOLD = 10; // 10+ recipients are routed to Team plans

export function discountForCount(count: number): number {
  if (count <= 1) return 0;
  if (count <= 3) return 0.15;
  return 0.25; // 4-9 (10+ is routed away before charging)
}

export function activeTier(count: number): 1 | 2 | 3 {
  if (count <= 1) return 1;
  if (count <= 3) return 2;
  return 3;
}

// Format a numeric amount using the currency symbol + ISO code already returned
// by the server quotation, e.g. "£161.50" / "$199 USD". Whole numbers drop the
// decimals to match the rest of the site.
export function formatMoney(amount: number, symbol: string): string {
  const whole = Math.round(amount) === amount;
  const value = whole
    ? amount.toLocaleString("en-GB")
    : amount.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${symbol}${value}`;
}
